import PanelMixinBack from '../components_mixins/PanelMixinBack';

export const PanelMixin = {
    props: {
        show: Boolean,
    },
    provide() {
        return { panel: this };
    },
    data: function() {
        return {
            loading: 0,
        };
    },
    components: { PanelMixinBack },
    mounted() {
        this.$onInstance('openGlobalPanel', (type) => {
            if (type != this.type) this.$emit('update:show', false);
        });
    },
    watch: {
        show: {
            immediate: true,
            handler(value) {
                if (value) this.$emitInstance('openGlobalPanel', this.type);
            },
        },
    },
};
